import SidebarMenuBlock from './SidebarMenuBlock';

export default SidebarMenuBlock;
